export default {
  data() {
    return {
      renderPopover: false,
      popOverEnabled: false,
      renderTimeout: null,
      visible: this.index < 9,
    };
  },
  computed: {
    showPopover() {
      return this.popOverEnabled && this.previewPopoverKey;
    },

    previewPopoverKey() {
      return this.$store.getters.getPreviewPopoverKey;
    },
  },
  methods: {
    displayPopover() {
      if (this.draggingIsOn || this.popOverEnabled) return;
      this.popOverEnabled = true;
    },
    hidePopover() {
      if (!this.popOverEnabled) return;
      this.popOverEnabled = false;
    },
    visibilityChanged(visible) {
      if (!visible) return;
      this.delayedRender();
      this.visible = visible;
    },
    delayedRender() {
      this.renderTimeout = setTimeout(() => {
        this.renderPopover = true;
      }, 400);
    },
  },

  beforeUnmount() {
    clearTimeout(this.renderTimeout);
  },
};
